import { ChangeEvent } from "react";
import { setHeight, setWidth, setIsLocked } from "store/features/enlarge/actions";
import { enlargeSelector } from "store/features/enlarge/selectors/enlargeSelector";
import { EnlargeState } from "store/features/enlarge/types";
import { useAppDispatch, useAppSelector } from "store/store";

export const useSize = () => {
    const {
        resizeSettings: {
            byDimension: { height, width },
            isLocked,
        },
    } = useAppSelector(enlargeSelector, equalityFn);

    const dispatch = useAppDispatch();

    const handleHeightChange = (e: ChangeEvent<HTMLInputElement>) => dispatch(setHeight(Number(e.target.value)));

    const handleWidthChange = (e: ChangeEvent<HTMLInputElement>) => dispatch(setWidth(Number(e.target.value)));

    const toggleLock = () => dispatch(setIsLocked(!isLocked));

    return {
        height,
        width,
        handleHeightChange,
        handleWidthChange,
        isLocked,
        toggleLock,
    };
};

const equalityFn = (left: EnlargeState, right: EnlargeState) => {
    if (
        left.resizeSettings.byDimension.width !== right.resizeSettings.byDimension.width ||
        left.resizeSettings.byDimension.height !== right.resizeSettings.byDimension.height ||
        left.resizeSettings.isLocked !== right.resizeSettings.isLocked
    )
        return false;

    return true;
};
